import { SavedSearchDto, SavedSearchPage } from '@creditsights/api-ui-web';
import { Button, ButtonMode, ButtonSize, Tooltip } from '@creditsights/styleguide-web';
import { isNil } from 'lodash';
import { ReactElement } from 'react';
import { useGlobalModalContext } from '../GlobalModal';
import { MODAL_TYPES } from '../GlobalModal/GlobalModal';
import { Filters } from '../../models';
import { SortOption } from '../../services/services.constants';

interface SaveSearchButtonProps {
  searchResultsCount: number | undefined;
  pageName: SavedSearchPage;
  searchTerm: string;
  tab: string;
  filters: Filters | null;
  sort: SortOption;
}

const SaveSearchButton = ({
  searchResultsCount,
  pageName,
  searchTerm,
  tab,
  filters,
  sort,
}: SaveSearchButtonProps): ReactElement => {
  const { showModal } = useGlobalModalContext();
  const searchResultsCountLoading = isNil(searchResultsCount);

  const onSaveSearch = () => {
    const savedSearchDto: Partial<SavedSearchDto> = {
      keywords: searchTerm,
      pageName,
      sort,
      tab,
      filters:
        filters?.tags &&
        Object.keys(filters.tags).map((key) => ({
          filterType: key,
          tags: filters.tags![key],
        })),
      dateRange:
        filters?.endDate || filters?.startDate || filters?.relativeRange
          ? {
              endDate: filters?.relativeRange ? undefined : filters?.endDate?.toISOString(),
              startDate: filters?.relativeRange ? undefined : filters?.startDate?.toISOString(),
              relativeRange: filters?.relativeRange,
            }
          : null,
    };

    showModal(MODAL_TYPES.SAVE_SEARCH, { search: savedSearchDto });
  };

  return (
    <div>
      <Tooltip content="No results to save" disabled={searchResultsCountLoading || searchResultsCount > 0}>
        <div>
          <Button
            loading={searchResultsCountLoading}
            disabled={!searchResultsCount}
            mode={ButtonMode.SECONDARY}
            size={ButtonSize.SMALL}
            onClick={onSaveSearch}
            ariaLabel="Save Search"
            dataTestId="save-search-button"
          >
            Save Search
          </Button>
        </div>
      </Tooltip>
    </div>
  );
};

export default SaveSearchButton;
